import React, { useState, useEffect } from 'react';
import { Table } from 'react-bootstrap';
import '../styles/list_role.css'

function ListRole() {
    const [faculty, setFaculty] = useState('');
    const [role, setRole] = useState('User');
    const [data, setData] = useState([
        {
            id: 1,
            username: "dia",
            fakultas: "idk",
            role: "User"
        },
        {
            id: 2,
            username: "kamu",
            fakultas: "idk",
            role: "Admin"
        }
    ]);
    const [inEditMode, setInEditMode] = useState({
        status: false,
        rowKey: null
    });

    useEffect(() => {
        // TODO call api update data
    });

    const headers = ["Username", "Fakultas", "Role", ""];

    const onEdit = ({ id, currentRole, currentFaculty }) => {
        setInEditMode({
            status: true,
            rowKey: id
        })

        setRole(currentRole);
        setFaculty(currentFaculty);
    }

    const updateRole = () => {
        // TODO call api to update role data
    }

    const onSave = () => {
        // call updateRole
    }

    const onCancel = () => {
        setInEditMode({
            status: false,
            rowKey: null
        });
    }

    return (
        <div className="list_role">
            <h2>Daftar Pengguna</h2>

            <Table
                striped bordered hover size="sm"
            >
                <thead>
                    <tr>
                        {headers.map((header, idx) => (
                            <th key={idx}>{header}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {
                        data.map((item) => (
                            // TODO update data attribute according to role after backend update
                            <tr key={item.id}>
                                <td>
                                    {item.username}
                                </td>
                                <td>
                                    {
                                        inEditMode.status && inEditMode.rowKey === item.id ? (
                                            <input value={faculty}
                                                onChange={(event) => setFaculty(event.target.value)}
                                            />
                                        ) : (
                                            item.fakultas
                                        )
                                    }
                                </td>
                                <td>
                                    {
                                        inEditMode.status && inEditMode.rowKey === item.id ? (
                                            <input value={role}
                                                onChange={(event) => setRole(event.target.value)}
                                            />
                                        ) : (
                                            item.role
                                        )
                                    }
                                </td>
                                <td>
                                    {
                                        inEditMode.status && inEditMode.rowKey === item.id ? (
                                            <React.Fragment>
                                                <button
                                                    className={"btn-success"}
                                                    // TODO onsave
                                                    onClick={() => onSave()}
                                                >
                                                    Save
                                                </button>

                                                <button
                                                    className={"btn-secondary"}
                                                    style={{ marginLeft: 8 }}
                                                    onClick={() => onCancel()}
                                                >
                                                    Cancel
                                                </button>
                                            </React.Fragment>
                                        ) : (
                                            <button
                                                className={"btn-primary"}
                                                onClick={() => onEdit({ id: item.id, currentRole: item.role, currentFaculty: item.fakultas })}
                                            >
                                                Edit
                                            </button>
                                        )
                                    }
                                </td>
                            </tr>
                        ))
                    }
                </tbody>
            </Table>
        </div>
    );
}

export default ListRole;
